exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n\n    position: relative;\n\n    vertical-align: middle;\n\n    fill: currentcolor;\n    stroke: none;\n}\n\nsvg {\n    pointer-events: none;\n    display: block;\n    width: 24px;\n    height: 24px;\n}\n\nsvg-parent {\n    width: 24px;\n    height: 24px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/polymer/iron-icon/iron-icon.component.css
// module id = ./src/app/components/polymer/iron-icon/iron-icon.component.css
// module chunks = main